import { InputTypes } from 'constants/enums';
import { IFormField } from 'models/app';
import React from 'react';
import Modal from 'components/UI/DialogModal';
import Form from 'components/UI/Form';
import { CircularProgress, Grid, Stack } from '@mui/material';
import MuiButton from 'components/UI/MuiButton';
import { useTranslation } from 'react-i18next';


interface Props {
  open: boolean;
  loading: boolean;
  onClose: () => void;
  onSubmit: () => void;
  onChanges: (name: string, value: any) => void;
}




const AddWorkshopEvaluationQuestionDimension: React.FC<Props> = ({ open, loading, onClose, onSubmit, onChanges }) => {
const {t}= useTranslation()
  let basicFields: IFormField[] = [
    {
      name: 'description',
      label: t('T_description'),
      type: InputTypes.TEXT,
      placeholder: t('T_enter_description'),
      internalLabel: true,
      required: true
    },
    {
      name: 'descriptionAr',
      label:  `${t('T_enter_description')} ${t('T_in_arabic')}`,  
      type: InputTypes.TEXT,
      placeholder:  `${t('T_enter_description')} ${t('T_in_arabic')}`,
      internalLabel: true,
      required: true
    }
  ];



  return (<>

    <Modal
      open={open}
      onClose={onClose}
      title={t('T_add_evaluation_question_dimension')}
      maxWidth="lg"
      children={<Stack spacing={2} p={2} >
        <Form fields={basicFields} onChange={onChanges} />
      </Stack>}
      actions={
        <Grid container alignItems={'center'} justifyContent={'space-between'} px={1} >
          <MuiButton variant="contained"
            sx={{ bgcolor: 'warning.main', color: 'white' }}
            size='large' onClick={onClose}>
            {t('T_cancel')}
          </MuiButton>
          <MuiButton variant="contained"
            sx={{ bgcolor: 'primary.main', color: 'white' }}
            disabled={loading}
            size='large' onClick={onSubmit}>
            {t('T_add')}
            <CircularProgress
              size={10}
              sx={{ mx: 2, display: loading ? "" : "none" }}
            />
          </MuiButton>

        </Grid>
      }
    />
  </>
  );
};

export default AddWorkshopEvaluationQuestionDimension;
